import { gql } from '@apollo/client';
import { FAMILY_SUMMARY_FRAGMENT } from './Summary';

export const ONBOARDING_STATUS_FRAGMENT = gql`
  fragment OnboardingStatusFields on OnboardingStatus {
    completed
    featureIntroStatus {
      digest
      inviteCreate
    }
  }
`;

export const USER_FIELDS = gql`
  fragment UserFields on User {
    id
    email
    firstName
    lastName
    profilePictureUrl
    spouseEmail
    spouse {
      id
      email
      firstName
      lastName
      profilePictureUrl
    }
    onboardingStatus {
      ...OnboardingStatusFields
    }
    family {
      ...FamilySummaryFragment
    }
  }
  ${FAMILY_SUMMARY_FRAGMENT}
  ${ONBOARDING_STATUS_FRAGMENT}
`;


export const USER_WITH_MATCHED_FAMILY = gql`
  fragment UserWithMatchedFamilyFields on User {
    id
    email
    firstName
    lastName
    profilePictureUrl
    spouseEmail
    spouse {
      id
      email
      firstName
      lastName
      profilePictureUrl
    }
    onboardingStatus {
      ...OnboardingStatusFields
    }
    family {
      ...FamilySummaryFragment
    }
    matchedFamily {
      ...FamilySummaryFragment
    }
  }
  ${FAMILY_SUMMARY_FRAGMENT}
  ${ONBOARDING_STATUS_FRAGMENT}
`;
